import { Link } from 'react-router-dom';
import { useFeaturedCategories } from '../products/api';
import { uploadUrl } from '../../lib/format';

/** §4.2: keep every featured category visible on mobile, with image and actual count. */
export function CategoryCarousel(): JSX.Element {
  const { data: categories = [], isLoading } = useFeaturedCategories();
  return (
    <section
      className="mx-auto max-w-7xl px-4 py-5 md:px-6 md:py-8"
      aria-labelledby="home-categories"
    >
      <div className="flex items-center justify-between gap-3">
        <h2 id="home-categories" className="text-xl font-light text-navy-900 sm:text-2xl">
          Shop by category
        </h2>
        <Link
          to="/products"
          className="inline-flex min-h-11 items-center text-sm text-sky-ink hover:underline"
        >
          View all →
        </Link>
      </div>
      <div className="mt-2 grid grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-4">
        {isLoading
          ? Array.from({ length: 4 }, (_, i) => (
              <div key={i} className="h-20 rounded-lg bg-frost" aria-hidden />
            ))
          : categories.map((category) => (
              <Link
                key={category.id}
                to={`/category/${category.slug}`}
                className="flex min-w-0 items-center gap-3 rounded-lg border border-frost bg-white p-2 transition-colors hover:border-sky-500 sm:p-3"
              >
                {category.thumbnail ? (
                  <img
                    src={uploadUrl(category.thumbnail)}
                    alt=""
                    width={56}
                    height={56}
                    loading="lazy"
                    className="h-12 w-12 shrink-0 rounded-md object-contain sm:h-14 sm:w-14"
                  />
                ) : (
                  <span
                    aria-hidden
                    className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-cloud text-lg text-sky-ink"
                  >
                    ↗
                  </span>
                )}
                <span className="min-w-0">
                  <span className="block text-xs leading-snug text-navy-900 sm:text-sm">
                    {category.name}
                  </span>
                  <span className="mt-1 block text-xs text-neutral">
                    {category.productCount} {category.productCount === 1 ? 'product' : 'products'}
                  </span>
                </span>
              </Link>
            ))}
      </div>
      {!isLoading && categories.length === 0 && (
        <Link to="/products" className="inline-flex min-h-11 items-center text-sky-ink">
          Explore all products →
        </Link>
      )}
    </section>
  );
}
